module.exports = function() {
  return new Worker(__webpack_public_path__ + "f178a95fdbe86040ac3a.worker.js");
};